import { useState } from 'react';

import { IconButton } from '../../Shared';

export const SearchFilter = ({ search, onChangeSearch }) => {
  const [value, setValue] = useState(search);

  const onChangeValue = e => {
    setValue(e.target.value);
  };

  const onKeyDown = e => {
    if (e.key !== 'Enter') return;
    onChange();
  };

  const onChange = () => {
    if (search === value) return;

    onChangeSearch(prev => {
      return {
        ...prev,
        search: value,
      };
    });
  };

  const reset = () => {
    setValue('');

    if (search === '') return;

    onChangeSearch(prev => {
      return {
        ...prev,
        search: '',
      };
    });
  };

  const hasValue = !!value;

  return (
    <div className="relative w-[240px]">
      <IconButton
        buttonProps={{
          className: 'w-7 h-7 !absolute left-3 top-1/2 -translate-y-1/2',
          onClick: onChange,
        }}
        iconProps={{
          name: 'magnify',
          className: 'h-5',
        }}
      />
      <input
        value={value}
        onKeyDown={onKeyDown}
        onChange={onChangeValue}
        placeholder="Search"
        className="w-full rounded-full py-[11px] px-11 text-base-1000 border border-brand-900 text-[16px]/[24px] focus-visible:outline-none bg-transparent placeholder:text-base-800"
      />
      {hasValue && (
        <IconButton
          buttonProps={{
            className: 'w-6 h-6 !absolute right-3 top-1/2 -translate-y-1/2',
            onClick: reset,
          }}
          iconProps={{
            name: 'cross',
            className: 'h-4',
          }}
        />
      )}
    </div>
  );
};
